import { inject } from '@angular/core';
import { Router, UrlTree, type CanMatchFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanMatchFn = (_route, segments): boolean | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) return true;

  // Allow silent rehydration: if we have a token but no user yet, let routing proceed;
  // a resolver/effect in AppComponent will bootstrap the profile.
  if (auth.hasAccessToken()) return true;

  const redirectTo = '/' + segments.map((s) => s.path).join('/');
  return router.createUrlTree(['/login'], {
    queryParams: redirectTo && redirectTo !== '/' ? { redirectTo } : undefined,
  });
};
